module.exports = __webpack_public_path__ + "img/plus_d4.84917ba7.png";